import * as actionTypes from '../types/task';

export function getTaskList(payload) {
  return {
    type: actionTypes.GET_TASK_LIST,
    payload
  };
}

export function getTaskListSuccess(payload) {
  return {
    type: actionTypes.GET_TASK_LIST_SUCCESS,
    payload
  };
}

export function getTaskListFail(payload) {
  return {
    type: actionTypes.GET_TASK_LIST_FAIL,
    payload
  };
}

export function getSemiListByTask(payload) {
  return {
    type: actionTypes.GET_SEMI_LIST_BY_TASK,
    payload
  };
}

export function getSemiListByTaskSuccess(payload) {
  return {
    type: actionTypes.GET_SEMI_LIST_BY_TASK_SUCCESS,
    payload
  };
}

export function getSemiListByTaskFail(payload) {
  return {
    type: actionTypes.GET_SEMI_LIST_BY_TASK_FAIL,
    payload
  };
}

export function addTaskSemi(payload) {
  return {
    type: actionTypes.ADD_TASK_SEMI,
    payload
  };
}

export function addTaskSemiSuccess(payload) {
  return {
    type: actionTypes.ADD_TASK_SEMI_SUCCESS,
    payload
  };
}

export function addTaskSemiFail(payload) {
  return {
    type: actionTypes.ADD_TASK_SEMI_FAIL,
    payload
  };
}

export function addTaskZdvlLine(payload) {
  return {
    type: actionTypes.ADD_TASK_ZDVL_LINE,
    payload
  };
}

export function addTaskZdvlLineSuccess(payload) {
  return {
    type: actionTypes.ADD_TASK_ZDVL_LINE_SUCCESS,
    payload
  };
}

export function addTaskZdvlLineFail(payload) {
  return {
    type: actionTypes.ADD_TASK_ZDVL_LINE_FAIL,
    payload
  };
}

export function saveTask(payload) {
  return {
    type: actionTypes.SAVE_TASK,
    payload
  };
}

export function saveTaskSuccess(payload) {
  return {
    type: actionTypes.SAVE_TASK_SUCCESS,
    payload
  };
}

export function saveTaskFail(payload) {
  return {
    type: actionTypes.SAVE_TASK_FAIL,
    payload
  };
}

export function deleteTaskSemi(payload) {
  return {
    type: actionTypes.DELETE_TASK_SEMI,
    payload
  };
}

export function deleteTaskSemiSuccess(payload) {
  return {
    type: actionTypes.DELETE_TASK_SEMI_SUCCESS,
    payload
  };
}

export function deleteTaskSemiFail(payload) {
  return {
    type: actionTypes.DELETE_TASK_SEMI_FAIL,
    payload
  };
}

export function deleteTaskZdvlLine(payload) {
  return {
    type: actionTypes.DELETE_TASK_ZDVL_LINE,
    payload
  };
}

export function deleteTaskZdvlLineSuccess(payload) {
  return {
    type: actionTypes.DELETE_TASK_ZDVL_LINE_SUCCESS,
    payload
  };
}

export function deleteTaskZdvlLineFail(payload) {
  return {
    type: actionTypes.DELETE_TASK_ZDVL_LINE_FAIL,
    payload
  };
}

export function getZdvlListForAdd(payload) {
  return {
    type: actionTypes.GET_ZDVL_LIST_FOR_ADD,
    payload
  };
}

export function getZdvlListForAddSuccess(payload) {
  return {
    type: actionTypes.GET_ZDVL_LIST_FOR_ADD_SUCCESS,
    payload
  };
}

export function getZdvlListForAddFail(payload) {
  return {
    type: actionTypes.GET_ZDVL_LIST_FOR_ADD_FAIL,
    payload
  };
}

export function deleteTask(payload) {
  return {
    type: actionTypes.DELETE_TASK,
    payload
  };
}

export function deleteTaskSuccess(payload) {
  return {
    type: actionTypes.DELETE_TASK_SUCCESS,
    payload
  };
}

export function deleteTaskFail(payload) {
  return {
    type: actionTypes.DELETE_TASK_FAIL,
    payload
  };
}

export function updateTask(payload) {
  return {
    type: actionTypes.UPDATE_TASK,
    payload
  };
}
export function updateTaskSuccess(payload) {
  return {
    type: actionTypes.UPDATE_TASK_SUCCESS,
    payload
  };
}
export function updateTaskClear(payload) {
  return {
    type: actionTypes.UPDATE_TASK_CLEAR,
    payload
  };
}
export function updateTaskFail(payload) {
  return {
    type: actionTypes.UPDATE_TASK_FAIL,
    payload
  };
}

export function setOpenCloseTask(payload) {
  return {
    type: actionTypes.SET_OPEN_CLOSE_TASK,
    payload
  };
}
export function setOpenCloseTaskSuccess(payload) {
  return {
    type: actionTypes.SET_OPEN_CLOSE_TASK_SUCCESS,
    payload
  };
}
export function setOpenCloseTaskFail(payload) {
  return {
    type: actionTypes.SET_OPEN_CLOSE_TASK_FAIL,
    payload
  };
}

export function setInitialStateTask(payload) {
  return {
    type: actionTypes.SET_INITIAL_STATE_TASK,
    payload
  };
}
